export default __webpack_public_path__ + "static/media/facebook.47554710.svg";